import React from "react";
import { Link } from "react-router-dom";
import "../../Styles/Firstcard.css"




export default function Fourthcard() {
    return (
        <div className="container my-4">
            <div className="special-header d-flex justify-content-between ">
                <h4 className="page-title mb-3">2023-2024</h4>
                <Link to="" className="btn custom-btn" title="View">Create</Link>

            </div>
            <div className="row">
                <div className="col-md-12 col-lg-4 col-sm-12 mb-4">
                    <div className="card kard1 text-center ">
                        <div className="card-body">
                            <h5 className="card-title"><b>testttt</b></h5>
                            <p className="card-text">Total FeeStructure Amount:$0</p>
                            <Link to="" className="btn"><i className="bi bi-arrow-up-right-square-fill"></i>View</Link>
                        </div>
                    </div>
                </div>
                <div className="col-md-12 col-lg-4 col-sm-12 mb-4">
                    <div className="card kard2 text-center" >
                        <div className="card-body">
                            <h5 className="card-title"><b>10(A)</b></h5>
                            <p className="card-text ">Total FeeStructure Amount:$24533</p>
                            <Link to="" className="btn"><i className="bi bi-arrow-up-right-square-fill"></i>View</Link>
                        </div>
                    </div>
                </div>
                <div className="col-md-12 col-lg-4 col-sm-12  mb-4">
                    <div className="card kard3 text-center">
                        <div className="card-body">
                            <h5 className="card-title"><b>GRADE 6</b></h5>
                            <p className="card-text">Total FeeStructure Amount:$0</p>
                            <Link to="" className="btn"><i className="bi bi-arrow-up-right-square-fill"></i>View</Link>
                        </div>
                    </div>
                </div>
                <div className="col-md-12 col-lg-4 col-sm-12  mb-4">
                    <div className="card kard4 text-center">
                        <div className="card-body">
                            <h5 className="card-title"><b>HARMONIUM1</b></h5>
                            <p className="card-text">Total FeeStructure Amount:$0</p>
                            <Link to="" className="btn"><i className="bi bi-arrow-up-right-square-fill"></i>View</Link>
                        </div>
                    </div>
                </div>
                <div className="col-md-12 col-lg-4 col-sm-12  mb-4">
                    <div className="card kard5 text-center">
                        <div className="card-body">
                            <h5 className="card-title"><b>7th(A)</b></h5>
                            <p className="card-text">Total FeeStructure Amount:$0</p>
                            <Link to="" className="btn"><i className="bi bi-arrow-up-right-square-fill"></i>View</Link>
                        </div>
                    </div>
                </div>
                <div className="col-md-12 col-lg-4 col-sm-12  mb-4">
                    <div className="card kard6 text-center">
                        <div className="card-body">
                            <h5 className="card-title"><b>7(A)</b></h5>
                            <p className="card-text">Total FeeStructure Amount:$10000</p>
                            <Link to="" className="btn"><i className="bi bi-arrow-up-right-square-fill"></i>View</Link>
                        </div>
                    </div>
                </div>
                <div className="col-md-12 col-lg-4 col-sm-12  mb-4">
                    <div className="card kard7 text-center">
                        <div className="card-body">
                            <h5 className="card-title"><b>LKG</b></h5>
                            <p className="card-text">Total FeeStructure Amount:$760000</p>
                            <Link to="" className="btn"><i className="bi bi-arrow-up-right-square-fill"></i>View</Link>
                        </div>
                    </div>
                </div>
                <div className="col-md-12 col-lg-4 col-sm-12  mb-4">
                    <div className="card kard8 text-center">
                        <div className="card-body">
                            <h5 className="card-title"><b>12</b></h5>
                            <p className="card-text">Total FeeStructure Amount:$20000</p>
                            <Link to="" className="btn"><i className="bi bi-arrow-up-right-square-fill"></i>View</Link>
                        </div>
                    </div>
                </div>
                <div className="col-md-12 col-lg-4 col-sm-12  mb-4">
                    <div className="card kard9 text-center">
                        <div className="card-body">
                            <h5 className="card-title"><b>Carnation (Weekend)</b></h5>
                            <p className="card-text">Total FeeStructure Amount:$740000</p>
                            <Link to="" className="btn"><i className="bi bi-arrow-up-right-square-fill"></i>View</Link>
                        </div>
                    </div>
                </div>
                <div className="col-md-12 col-lg-4 col-sm-12  mb-4">
                    <div className="card kard10 text-center">
                        <div className="card-body">
                            <h5 className="card-title"><b>KG1</b></h5>
                            <p className="card-text">Total FeeStructure Amount:$0</p>
                            <Link to="" className="btn"><i className="bi bi-arrow-up-right-square-fill"></i>View</Link>
                        </div>
                    </div>
                </div>
                <div className="col-md-12 col-lg-4 col-sm-12  mb-4">
                    <div className="card kard11 text-center">
                        <div className="card-body">
                            <h5 className="card-title"><b>Sunflower</b></h5>
                            <p className="card-text">Total FeeStructure Amount:$0</p>
                            <Link to="" className="btn"><i className="bi bi-arrow-up-right-square-fill"></i>View</Link>
                        </div>
                    </div>
                </div>
                <div className="col-md-12 col-lg-4 col-sm-12  mb-4">
                    <div className="card kard12 text-center" >
                        <div className="card-body">
                            <h5 className="card-title"><b>KG1</b></h5>
                            <p className="card-text">Total FeeStructure Amount:$720000</p>
                            <Link to="" className="btn"><i className="bi bi-arrow-up-right-square-fill"></i>View</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    );
}